export const getOffsetAfterDeletion = (
  totalCount: number,
  currentOffset: number,
  itemsPerPage: number,
  currentItemsCount: number
): number | null => {
  const isLastPage = currentOffset + itemsPerPage >= totalCount;
  const wasLastItemOnPage = currentItemsCount === 1;

  if (isLastPage && wasLastItemOnPage && currentOffset > 0) {
    return Math.max(0, currentOffset - itemsPerPage);
  }

  return null;
};